import React from 'react';
import cx from 'classnames';
import { Field } from 'redux-form';
import { compose, withHandlers } from 'recompose';
import Icon from 'components/Icon';
import { Typo } from 'components/Layout';

import styles from './styles.css';

const Item = withHandlers({
  onClick:
    ({ onChange, value, selected }) =>
    (e) => {
      if (selected) return;
      return onChange(value);
    },
})(({ onClick, title, body, disabled, selected, size }: any) => {
  // Renders the title, optionally with a "NEW!" badge for new recommendation types
  const renderTitle = () => {
    if (!title) return null;

    const isNewRecoType =
      title === 'Personalized Recommendations' || title === 'Trending Products';
    if (isNewRecoType) {
      return (
        <div className={styles.titleWrapper}>
          <Typo.Title className={styles.newRecoTitle} size="small">
            {title}
          </Typo.Title>
          <span className={styles.pillNew}>NEW!</span>
        </div>
      );
    }

    return <Typo.Title size="small">{title}</Typo.Title>;
  };

  return (
    <button
      onClick={onClick}
      className={cx(
        styles.item,
        styles[`size-${size}`],
        selected && styles.selected,
        disabled && styles.disabled
      )}
    >
      <div className={styles.body}>
        {renderTitle()}
        {body &&
          ((React.isValidElement(body) && body) ||
            React.createElement(body, { selected }))}
      </div>
    </button>
  );
});

export const Component = ({
  meta: { touched, error },
  className,
  items,
  input,
  size = 2,
}) => (
  <div className={cx(styles.root, className)}>
    {touched && error && <div className={styles.error}>{error}</div>}
    <div className={styles.wrapper}>
      {items.map((item, i: number) => (
        <Item
          key={i}
          size={size}
          {...input}
          {...item}
          selected={input.value === item.value}
        />
      ))}
    </div>
  </div>
);

export const SelectBoxes = (props) => (
  <Field component={Component} {...props} />
);
